import React from "react";

export default function ErrorDisplay({ errors }) {
  return (
    <>
      {Object.keys?.(errors)?.map((item, index) => (
        <span
          key={index}
          style={{
            color: "red",
            fontSize: "12px",
            fontWeight: "500",
            marginBottom: "10px",
          }}
        >
          {errors[item]}
          <br />
        </span>
      ))}
    </>
  );
}
